import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

interface Props {
  variant?: 'create' | 'edit'
}

const createDescription = 'Enter details of your space.'

const editDescription = 'Details of your space.'

const SpaceGeneralDetails = ({
  variant = 'create'
}: Props) =>
  <Paragraph>
    <strong>
      {
        variant === 'create'
          ? (
            <Color variant='theme-description-text'>
              {createDescription}
            </Color>
          )
          : editDescription
      }

    </strong>
  </Paragraph>

export default SpaceGeneralDetails
